export default __webpack_public_path__ + "static/media/P945_B_BD.1f5d1709.pdf";